import CHECK24RAW from './external/check24_at.js?raw';

try {
    eval.call(window, CHECK24RAW);
} catch (err) {
    console.error(err);
}

try {
    // Standard Vars
    window.CHECK24_HOST = 'www.check24.at';

    // Default Options
    window.Check24.setDomain('check24.at');

    // Set hovering header
    window.Check24.headerHover.init();
    window.Check24.cookieBanner.init();
    /* EXECUTE COOKIE LOGIC - REMOVE WHEN EVENT IS TRIGGERED THROUGH HOLDING */
    window.TCMS.helper.checkConsentCookie();

    // Login Layer
    // window.Check24.meinKonto.loginLayer(); // Nicht auf SEO Seiten verwenden
} catch (err) {
    console.error(err);
}
